export default __webpack_public_path__ + "static/media/favicon-57.4fbad948.png";